const getCookie = n => document.cookie.split('; ').find(c=>c.startsWith(n+'='))?.split('=')[1] || '';
const setCookie = (n,v,days=180) =>
  document.cookie = `${n}=${v}; path=/; expires=${new Date(Date.now()+days*864e5).toUTCString()}`;
const safe = s => String(s||'').trim().toLowerCase().replace(/[^a-z0-9._-]+/g,'-').slice(0,64);

document.addEventListener('DOMContentLoaded', () => {
  const isPPC = /ppc/i.test(location.href) || document.cookie.includes('ppc=');
  if (isPPC) {
    setCookie('ppc','1',30);
    document.querySelectorAll('.popup__title, .popup__description, [data-popup-inner] .rte, [data-popup-inner] .popup__text, [data-popup-inner] .popup__body, newsletter-form .form-success')
      .forEach(el => el.childNodes.forEach(n => {
        if (n.nodeType === 3) n.nodeValue = n.nodeValue.replace(/\b20\b/g,'30');
      }));
    document.querySelectorAll('input#contactTags').forEach(inp => {
      if (!inp.value.split(',').includes('ppc')) inp.value += ',ppc';
    });
    document.querySelectorAll('[data-discount-target]').forEach(el => el.textContent = 'EXPLORE30');
  }

  const host = location.hostname;
  const refHostNow = (() => { try { return new URL(document.referrer).hostname; } catch { return ''; } })();
  const isExternal = refHostNow && refHostNow !== host;
  const p = new URLSearchParams(location.search);
  const acqNow = p.get('campaign') || p.get('utm_campaign') || p.get('ad') ||
                 (p.getAll('utm_campaign').find(v => v && v.includes('$')) || '');
  const term = p.get('utm_term') || '';
  const matchType = p.get('mt') || '';
  const adGroup = p.get('adg') || '';

  if (isExternal && getCookie('ft_ref') !== refHostNow) setCookie('ft_ref', refHostNow, 180);
  if (acqNow && !getCookie('ft_campaign')) setCookie('ft_campaign', acqNow, 180);
  if (acqNow) setCookie('acq_campaign', acqNow, 30);

  const tagRef = getCookie('ft_ref') || (isExternal ? refHostNow : '');
  const tagCamp = getCookie('ft_campaign') || acqNow || getCookie('acq_campaign') || '';

  document.querySelectorAll('input#contactTags').forEach(inp => {
    const set = new Set(inp.value.split(',').map(s=>s.trim()).filter(Boolean));
    if (tagRef) { set.add(`ref:${safe(tagRef)}`); set.add('has_ref'); }
    if (tagCamp) { set.add(`campaign:${safe(tagCamp)}`); set.add('has_campaign'); }
    if (tagRef || tagCamp) set.add('to_sort');
    inp.value = Array.from(set).join(',');
  });

  const cartAttrs = {};
  if (tagRef) cartAttrs['ref'] = tagRef;
  if (tagCamp) cartAttrs['campaign'] = tagCamp;
  if (isPPC) cartAttrs['ppc'] = '1';
  cartAttrs['term'] = term || null;
  cartAttrs['match_type'] = matchType || null;
  cartAttrs['ad_group'] = adGroup || null;
  if (Object.keys(cartAttrs).length) {
    fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ attributes: cartAttrs })
    }).catch(()=>{});
  }

  document.querySelectorAll('form[data-newsletter-form], form.newsletter-form').forEach(form => {
    form.addEventListener('submit', evt => {
      const email = form.querySelector('input[type="email"]');
      if (email && !email.checkValidity()) { email.reportValidity(); evt.preventDefault(); return; }

      const consent = getCookie('userConsent');
      if (!consent) return;

      try {
        const tagsEl = form.querySelector('#contactTags');
        if (!tagsEl) return;
        const purposes = JSON.parse(consent).purposes || {};
        const newTags = Object.entries(purposes).filter(([,v]) => !!v).map(([k]) => `purpose_${k}`);
        const merged = new Set(tagsEl.value.split(',').map(s=>s.trim()).filter(Boolean));
        newTags.forEach(t => merged.add(t));
        tagsEl.value = Array.from(merged).join(',');
      } catch(_) {}
    }, {capture:true});
  });
});